module.exports = __webpack_public_path__ + "static/img/achiev_icon_gray.13c28af1.png";